import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import {
  createService,
  getServiceById,
  updateService,
} from "../../../../store/slices/servicesSlice";
import { getAllPrograms } from "../../../../store/slices/programsSlice";
import { useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import CreatetableSelect from "react-select/creatable";
import UploadComponent from "../../Components/uploadComponent";
import Swal from "sweetalert2";

const ServiceForm = forwardRef((props, ref) => {
  const { formType, toggle, pagination } = props;
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState({
    name: "",
    description: "",
    program_id: "",
    type: "grouped",
  });
  const [file, setFile] = useState(null);

  const serviceDetails = useSelector((state) => state.services.serviceDetail);
  const allServices = useSelector((state) => state.services.allServices).map(
    (service) => ({ label: service?.name, value: service.ID })
  );

  const {
    register,
    trigger,
    formState: { errors },
    setValue,
    control,
    getValues,
  } = useForm({ defaultValues: { name: "", description: "", program_id: null, type: "grouped" } });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    role_value: {
      ...register("name", { required: "This field is required" }),
    },
    description: {
      ...register("description", { required: "This field is required" }),
    },
    program_id: {
      ...register("program_id", { required: "This field is required" }),
    },
    // type is now handled by Controller
  });

    const [typeOfBenefit, setTypeOfBenfefit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);

  const allPrograms = useSelector(
    (state) => state.programs.allProgramsData
  ).map((program) => ({
    label: program.name,
    value: program.ID,
  }));

  useEffect(() => {
    fetchAllPrograms();
    if (formType === "edit") {
      init();
    }
    // ensure default type is set for creation
    if (formType === "create") {
      setValue("type", "grouped");
    }
  }, []);

 

useImperativeHandle(ref, () => ({
  async handleSubmit() {
    const isValid = await trigger();
    if (!isValid) return;

    let payload = {
      description: formFields.description || "",
      type: formFields.type || "grouped",
    };

    if (formFields.name) {
      if (formFields.name.__isNew__) {
        payload = { ...payload, isNew: true, name: formFields.name.label };
      } else {
        payload = { ...payload, service_id: formFields.name.value };
      }
    }
    if (formFields.program_id) {
      payload.program_id = formFields.program_id.value;
    }

    try {
      if (formType === "edit") {
        await dispatch(
          updateService({
            ...payload,
            ID: formFields.ID,
          })
        ).unwrap();

        Swal.fire({
          title: "Form updated",
          text: "Your form has been updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
          timer: 1800,
          timerProgressBar: true,
        });
      } else {
        if (file) {
          const formData = new FormData();
          Object.entries(payload).forEach(([k, v]) => {
            if (v !== undefined && v !== null) {
              formData.append(k, v);
            }
          });
          formData.append("file", file);

          await dispatch(createService({ formData, pagination, file })).unwrap();
        } else {
          await dispatch(createService({ payload, pagination, file: null })).unwrap();
        }

        Swal.fire({
          title: "Service created",
          text: "Your service has been created successfully.",
          icon: "success",
          confirmButtonText: "OK",
          timer: 1800,
          timerProgressBar: true,
        });

        toggle();
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong while saving the service.",
        icon: "error",
        confirmButtonText: "OK",
      });
      console.error("Service submission failed:", error);
    }
  },
}));


  const handleInput = (event, field) => {
    console.log(event, field);

    let value;
    if (field === "name") {
      value = event;
    } else if (field === "description") {
      value = event;
    } else if (field === "program_id") {
      value = event;
    } else if(field === "type"){
      // Controller manages the form value, just update local state
      setFormFields({ ...formFields, type: event?.value || "" });
      return; // Don't call setValue since Controller handles it
    }
    else {
      value = event.target.value;
    }

    setValue(field, value);
    setFormFields({ ...formFields, [field]: value });
  };

  const init = () => {
    console.log(serviceDetails, "service details");
    dispatch(getServiceById(serviceDetails.ID));

    Object.keys(serviceDetails).forEach((key) => {
      if (key === "program_id") {
        setValue(key, {
          label: serviceDetails["Program"]?.name,
          value: serviceDetails["Program"]?.ID,
        });
      } else if (key === "type") {
        setValue(key, serviceDetails[key] || "grouped");
      } else {
        setValue(key, serviceDetails[key]);
      }
    });
    setFormFields({
      ID: serviceDetails.ID,
      name: serviceDetails.name,
      description: serviceDetails.description,
      program_id: {
        label: serviceDetails["Program"]?.name,
        value: serviceDetails["Program"]?.ID,
      },
      type: serviceDetails.type || "grouped",
    });
  };

  const fetchAllPrograms = () => {
    dispatch(getAllPrograms());
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  return (
    <div className="px-2">
      <div>
        <Label>Select Program<span className="text-danger">*</span></Label>
        <Controller
          name="program_id"
          control={control}
          rules={{ required: "This field is required" }}
          render={({ field }) => (
            <Select
              {...field}
              options={allPrograms}
              value={allPrograms.find((p) => p.value === field.value?.value)}
              className="js-example-basic-single col-sm-12"
              onChange={(selected) => {
                field.onChange(selected);
                handleInput(selected, "program_id");
              }}
              required
            />
          )}
        />
        {errors.program_id && (
          <span className="mt-1 text-danger">{errors.program_id.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Service Name<span className="text-danger">*</span></Label>

        <CreatetableSelect
          options={allServices}
          onChange={(event) => handleInput(event, "name")}
          isClearable
          required
        />
        {errors.name && (
          <span className="mt-1 text-danger">{errors.name.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Service Description<span className="text-danger">*</span></Label>
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          value={formFields.description}
          onChange={(event) => handleInput(event, "description")}
        />

        {errors.description && (
          <span className="mt-1 text-danger">{errors.description.message}</span>
        )}
      </div>
      <div className="mt-4">
                  <Label>Select Benefit Type</Label>
                 <Controller
                   name="type"
                   control={control}
                   rules={{ required: "This field is required" }}
                   render={({ field }) => (
                     <CreatetableSelect
                       {...field}
                       options={typeOfBenefit}
                       value={typeOfBenefit.find((x) => x.value === field.value)}
                       onChange={(selected) => {
                         field.onChange(selected?.value || "");
                         handleInput(selected, "type");
                       }}
                     />
                   )}
                 />
                  {errors.type && (
                    <span className="mt-1 text-danger">{errors.type.message}</span>
                  )}
                </div>
      <div className="mt-4">
        <UploadComponent addFile={setFile} />
      </div>
    </div>
  );
});

export default ServiceForm;
